import { createSelector } from 'reselect'

import { apiSlice } from './api';

import _ from 'lodash'

export const selectParentCategories = createSelector(
    apiSlice.endpoints.getCategories.select(),
    (result) => {
        return result.data ? _.chain(result.data)
        .map(c =>  { return c.parent })
        .uniq()
        .pull(0)
        .value()
        : []
    }
)

export const selectCategoriesWithChildren = createSelector(
    apiSlice.endpoints.getCategories.select(),
    (result) => {
        let output = {};

        if(result.data){
            _.each(result.data, c => {
                const key = c.parent || c.id;
                if(!_.has(output, key)){
                    output[key] = [];
                }
                output[key].push(c.id);
            })
        }

        return output; 
    }
)